
"use client";

import Image from "next/image";
import { Card, CardContent } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { cn } from "@/lib/utils";

const galleryImages = [
  { src: "/img/1.jpg", alt: "Happy people at the event.", hint: "event crowd" },
  { src: "/img/2.jpg", alt: "A chef giving a cooking demonstration.", hint: "cooking show" },
  { src: "/img/3.jpg", alt: "Colorful display of gluten-free products.", hint: "food products" },
];

export function Gallery() {
  return (
    <Carousel
      opts={{
        align: "start",
        loop: true,
      }}
      className="w-full"
    >
      <CarouselContent>
        {galleryImages.map((image, index) => (
          <CarouselItem key={index} className="basis-full md:basis-1/2 lg:basis-1/3 p-2">
            <Card>
              <CardContent className="flex aspect-video items-center justify-center p-0 overflow-hidden rounded-lg">
                <Image
                  src={image.src}
                  alt={image.alt}
                  width={800}
                  height={600}
                  className="w-full h-full object-cover object-center transition-transform duration-500 ease-in-out hover:scale-110"
                  data-ai-hint={image.hint}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                />
              </CardContent>
            </Card>
          </CarouselItem>
        ))}
      </CarouselContent>
      <CarouselPrevious className="hidden sm:flex" />
      <CarouselNext className="hidden sm:flex" />
    </Carousel>
  );
}
